var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map(function(p){return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = function(scope, key) {
	return scope && __webpack_require__.o(scope, key);
}
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = function(versions) {
	return Object.keys(versions).reduce(function(filtered, version) {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = function(scope, key, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = function(scope, key, requiredVersion, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key, eager) {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion, eager) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = function(msg) {
	throw new Error(msg);
}
var failAsNotExist = function(scopeName, key) {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ function(msg) {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = function(fn) { return function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
}; };

var useFallback = function(scopeName, key, fallback) {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key, eager, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init(function(scopeName, scope, key, eager, requiredVersion, fallback) {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	50318: function() { return loadSingletonVersion("default", "react", false, [1,18,3,1], function() { return __webpack_require__.e(6817).then(function() { return function() { return __webpack_require__(49198); }; }); }); },
	2452: function() { return loadSingletonVersion("default", "react-router-dom", false, [1,6,30,1], function() { return Promise.all([__webpack_require__.e(1240), __webpack_require__.e(6512), __webpack_require__.e(6984), __webpack_require__.e(2696), __webpack_require__.e(676)]).then(function() { return function() { return __webpack_require__(16456); }; }); }); },
	72970: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-logging", false, [1,4,7,0], function() { return Promise.all([__webpack_require__.e(8030), __webpack_require__.e(2452)]).then(function() { return function() { return __webpack_require__(48030); }; }); }); },
	58765: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-authentication", false, [1,4,4,0], function() { return Promise.all([__webpack_require__.e(6512), __webpack_require__.e(6984), __webpack_require__.e(9017), __webpack_require__.e(1189)]).then(function() { return function() { return __webpack_require__(91189); }; }); }); },
	61198: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-business-entity", false, [1,7,11,0], function() { return Promise.all([__webpack_require__.e(1856), __webpack_require__.e(2452), __webpack_require__.e(2519)]).then(function() { return function() { return __webpack_require__(31856); }; }); }); },
	80676: function() { return loadSingletonVersion("default", "react-dom", false, [1,18,3,1], function() { return __webpack_require__.e(879).then(function() { return function() { return __webpack_require__(20879); }; }); }); },
	72519: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-loading", false, [1,1,1,0], function() { return __webpack_require__.e(1649).then(function() { return function() { return __webpack_require__(31649); }; }); }); },
	93630: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-clickstream", false, [1,4,18,0], function() { return Promise.all([__webpack_require__.e(6984), __webpack_require__.e(5555), __webpack_require__.e(2452), __webpack_require__.e(1198), __webpack_require__.e(6392)]).then(function() { return function() { return __webpack_require__(45555); }; }); }); },
	7653: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-ecommerce", false, [1,9,7,0], function() { return Promise.all([__webpack_require__.e(4977), __webpack_require__.e(1198)]).then(function() { return function() { return __webpack_require__(44977); }; }); }); },
	71985: function() { return loadSingletonVersion("default", "@emotion/react", false, [1,11,14,0], function() { return __webpack_require__.e(8002).then(function() { return function() { return __webpack_require__(45621); }; }); }); },
	81671: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-identity", false, [1,2,0,0], function() { return __webpack_require__.e(2788).then(function() { return function() { return __webpack_require__(42788); }; }); }); },
	96110: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-env", false, [1,2,5,0], function() { return __webpack_require__.e(8553).then(function() { return function() { return __webpack_require__(68553); }; }); }); },
	4676: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-experiments", false, [1,4,12,0], function() { return Promise.all([__webpack_require__.e(6175), __webpack_require__.e(1198)]).then(function() { return function() { return __webpack_require__(16175); }; }); }); },
	72765: function() { return loadSingletonVersion("default", "@zenbusiness/application-commons-pricelist", false, [1,4,0,0], function() { return __webpack_require__.e(6391).then(function() { return function() { return __webpack_require__(26391); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"318": [
		50318
	],
	"676": [
		80676
	],
	"1198": [
		61198
	],
	"2452": [
		2452
	],
	"2519": [
		72519
	],
	"2596": [
		4676,
		72765
	],
	"2970": [
		72970
	],
	"3630": [
		93630
	],
	"7609": [
		7653,
		71985,
		81671,
		96110
	],
	"8765": [
		58765
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}